import { logger } from "#/utils/logger";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { useEffect } from "react";

interface GoogleSignInButtonProps {
  onSuccess: (token: string) => void;
  onError?: (error: Error) => void;
  onLoad?: () => void;
  text?: string;
}

export const GoogleSignInButton = ({ onSuccess, onError, onLoad, text }: GoogleSignInButtonProps) => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

  useEffect(() => {
    if (clientId && onLoad) {
      onLoad();
    }
  }, [clientId, onLoad]);

  if (!clientId) {
    logger.error("Google Client ID not configured");
    return null;
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleLogin
        onSuccess={(credentialResponse) => {
          if (credentialResponse.credential) {
            onSuccess(credentialResponse.credential);
          }
        }}
        onError={() => {
          logger.error("Google Sign-In failed");
          onError?.(new Error("Google Sign-In failed"));
        }}
        text={text || "signin_with"}
        theme="outline"
        size="large"
        width="100%"
      />
    </GoogleOAuthProvider>
  );
};
